function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, JSON, Object) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'auth-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!$attr(`hide-header`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("auth-header"));;
          return __jade_nodes
        }).call(this)) : undefined); /*  should be a div with the .auth-form class */
        __jade_nodes = __jade_nodes.concat(h("slot", {
          "attrs": __vjadeStringifyAttrsIfObj({
            name: `auth-form-slot`
          }),
        }));
        __jade_nodes = __jade_nodes.concat(h("auth-footer", {
          "attrs": __vjadeStringifyAttrsIfObj({
            'show-footer-links': $attr(`show-footer-links`),
          }),
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;